import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthServiceService } from './auth-service.service';
import { MainServiceService } from './main-service.service';
import { JwtInterceptorService } from './jwt-interceptor.service';
import { ErrorInterceptor } from './error-interceptor.service';
import { AuthGuardService } from './auth-guard.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material';
import {MatButtonModule} from '@angular/material/button';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MasterDataProviderService } from './master-data-provider.service';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';

@NgModule({
  declarations: [
    AppComponent,    
    DynamicFormComponent    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,    
    MatCheckboxModule,
    PdfViewerModule

  ],
  entryComponents: [
  ],
  providers: [AuthServiceService,MainServiceService, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true }, JwtInterceptorService, ErrorInterceptor, AuthGuardService, 
    MasterDataProviderService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/app.module.ts